import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import uuid from 'react-uuid';
import { FIRM_INFO, LOG_IN, LOG_OUT, MEASUREMENT_DATE, USER_VALIDATION } from 'common/constants/process-management';
import { useStore } from 'common/store';
import { SecurePortalParams } from 'common/types/reactRouter';
import { UseStoreValues } from 'common/types/store';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import ProcessManagementRequestHeader from 'pages/ProcessManagement/ProcessManagementRequestHeader/ProcessManagementRequestHeader';
import ProcessManagementQuestionsForm from './ProcessManagementQuestionsForm/ProcessManagementQuestionsForm';

const ProcessManagementQuestions = () => {
  const { setHeaderMenuItems, questionnaireUrl, documentUrl } = useContext(TaskContext) as TaskContextType;
  const { requestId, hmacToken, processType } = useParams<SecurePortalParams>();
  const [{ user }] = useStore() as unknown as UseStoreValues;

  useEffect(() => {
    setHeaderMenuItems({
      left: [
        {
          id: uuid(),
          component: FIRM_INFO,
          label: '',
          link: '',
          withArrow: false,
          hideOnMobile: false,
        },
      ],
      right: [
        {
          id: uuid(),
          component: MEASUREMENT_DATE,
          label: '',
          link: '',
          withArrow: false,
          hideOnMobile: false,
        },
        {
          id: uuid(),
          label: user ? LOG_OUT : LOG_IN,
          link: `/${processType}/requests/${requestId}/${hmacToken}`,
          component: USER_VALIDATION,
          withArrow: false,
          hideOnMobile: false,
        },
      ],
    });
  }, [documentUrl, hmacToken, processType, questionnaireUrl, requestId, setHeaderMenuItems, user]);

  return (
    <>
      <ProcessManagementRequestHeader
        title="Additional Information"
        subtitle="Questions answered"
        requestedTasksType="questions"
      />
      <ProcessManagementQuestionsForm />
    </>
  );
};

export default ProcessManagementQuestions;
